import Email from 'components/Main/Emails/Email'
import useFetch from 'elements/Hooks/useFetch'
import React from 'react'

function RatingSystemCont() {
  const { data: list, fetching, fetch } = useFetch({
    url: '/emails?select=_id,_key,to,cc,bcc,from,subject,owner,detail',
  })

  return (
    <Email
      {...{
        list,
        fetching,
        fetch,
      }}
    />
  )
}

export default RatingSystemCont
